var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLivieAiHeader(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_1373_13148)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    rx: 13,
    fill: "#3B61E1"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1373_13148)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.32662 9.56193L6.31836 15.4957C6.31836 16.0411 6.62 16.5452 7.09933 16.8014L15.1032 21.0699C15.3636 21.2104 15.6611 20.979 15.6322 20.6401L15.5495 19.0369C15.533 18.7931 15.6074 18.7063 15.7396 18.6154L19.0825 16.3634C19.2643 16.2436 19.4131 16.0783 19.5164 15.8841C19.6197 15.6899 19.6734 15.475 19.6734 15.2601L19.6816 9.3264C19.6816 8.78096 19.38 8.27684 18.9007 8.02065L13.3554 5.06619C12.8719 4.80999 12.2893 4.83892 11.8347 5.1447L6.91338 8.45866C6.73157 8.57849 6.58282 8.74377 6.47951 8.93798C6.37621 9.13219 6.32662 9.34293 6.32662 9.56193ZM17.5495 15.3056C17.7933 15.1403 17.942 14.8634 17.942 14.5701V10.0454C17.9461 9.71895 17.7643 9.41731 17.4751 9.26029L13.1653 6.96283C12.876 6.80994 12.5248 6.82647 12.2521 7.00828L8.50012 9.53301C8.25632 9.69829 8.10757 9.97514 8.10757 10.2685V14.7932C8.10344 15.1196 8.28525 15.4213 8.5745 15.5783L12.8843 17.8758C13.1735 18.0286 13.5248 18.0121 13.7975 17.8303L17.5495 15.3056Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.64485 11.871L9.64231 12.9908C9.64138 13.4016 9.97363 13.7353 10.3844 13.7363L10.3885 13.7363C10.7993 13.7372 11.1331 13.405 11.134 12.9942L11.1365 11.8744C11.1375 11.4636 10.8052 11.1298 10.3945 11.1289L10.3903 11.1289C9.97954 11.128 9.64579 11.4602 9.64485 11.871Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2596 11.1264L12.2536 13.7379C12.2527 14.1486 12.585 14.4824 12.9957 14.4833L12.9999 14.4833C13.4106 14.4843 13.7444 14.152 13.7453 13.7413L13.7513 11.1298C13.7522 10.719 13.4199 10.3852 13.0092 10.3843L13.005 10.3843C12.5943 10.3833 12.2605 10.7156 12.2596 11.1264Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8656 11.8788L14.863 12.9986C14.8621 13.4094 15.1943 13.7431 15.6051 13.7441L15.6092 13.7441C16.02 13.745 16.3538 13.4128 16.3547 13.002L16.3572 11.8822C16.3582 11.4714 16.0259 11.1377 15.6152 11.1367L15.611 11.1367C15.2002 11.1358 14.8665 11.468 14.8656 11.8788Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 19.2999,
    y: 19.1895,
    width: 8.58313,
    height: 8.58313,
    rx: 4.29157,
    fill: "#4AC169",
    stroke: "#F5F5F5",
    strokeWidth: 1.71663
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_1373_13148",
    x: -9.28572,
    y: -9.28572,
    width: 47.3136,
    height: 47.2024,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 4.64286
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1373_13148"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1373_13148",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1373_13148"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.3633,
    height: 16.2144,
    fill: "white",
    transform: "translate(6.31836 4.89278)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLivieAiHeader);
export default __webpack_public_path__ + "static/media/livie-ai--header.f8eb511c06c5789c27ea18fcbafee2c2.svg";
export { ForwardRef as ReactComponent };